import { useMemo, useCallback } from 'react';
import { useOtherActionsContext } from '../../../pages/orders-page/containers/grid-header-container/other-actions-context-provider';
import { messages } from './messages';

export const useManagePresets = () => {
  const { openManagePresetsModal } = useOtherActionsContext();

  const actionHandler = useCallback(() => {
    openManagePresetsModal();
  }, [openManagePresetsModal]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsManagePresets,
      isDisabled: false,
      disabledReason: null,
    };
  }, [actionHandler]);
};
